import { render } from "./AppVerificaDocumenti.vue?vue&type=template&id=ea797152&scoped=true"
import script from "./AppVerificaDocumenti.vue?vue&type=script&lang=js"
export * from "./AppVerificaDocumenti.vue?vue&type=script&lang=js"

import "./AppVerificaDocumenti.vue?vue&type=style&index=0&id=ea797152&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea797152"]])

export default __exports__